import { CHECKOUT_MODES } from '@/components/flow/steps/checkout/types';
import FLOW_TYPES, {
  type FlowType,
} from '@/services/funnelService/consts/flowType';

export function getCheckoutMode(flowType: FlowType) {
  switch (flowType) {
    case FLOW_TYPES.SignupSkin:
    case FLOW_TYPES.AgencySignupSkin:
    case FLOW_TYPES.CurologyRetailOneTimeSkin:
      return CHECKOUT_MODES.Trial;
    case FLOW_TYPES.Resubscription:
    case FLOW_TYPES.ResubscriptionNonExpedited:
      return CHECKOUT_MODES.Subscription;
    case FLOW_TYPES.OneTimeRxSkin:
      return CHECKOUT_MODES.Cart;
    case FLOW_TYPES.NewTreatmentSkin:
      return CHECKOUT_MODES.Trial;
    case FLOW_TYPES.NewTreatmentChia:
      return CHECKOUT_MODES.Subscription;
    case FLOW_TYPES.SignupChia:
      return CHECKOUT_MODES.Subscription;
    default:
      throw new Error(
        `getCheckoutMode: No behavior defined for flowType: "${flowType}"`,
      );
  }
}
